import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Autocomplete, FormHelperText } from "__barrel_optimize__?names=Autocomplete,FormHelperText!=!@mui/material";
import React from "react";
const StyledAutoComplete = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { helperText, freeSolo, ...rest } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Autocomplete, {
                ref: ref,
                ...rest,
                freeSolo: freeSolo
            }),
            helperText ? /*#__PURE__*/ _jsx(FormHelperText, {
                sx: {
                    color: "#bf3333",
                    marginLeft: "16px !important"
                },
                children: helperText && helperText
            }) : null
        ]
    });
});
StyledAutoComplete.displayName = "StyledAutoComplete";
export default StyledAutoComplete;
